export const COMMON_ACTIONS = {
    LOADING: "LOADING"
}